<template>
  <div>
    <label
      v-if="label"
      :class="`${errors.length ? 'text-error' : 'text-zinc-800'} mb-1.5 block leading-normal`"
      :for="id"
    >
      {{ `${label}${required ? '*' : ''}` }}
    </label>

    <div class="relative">
      <div
        class="pointer-events-none absolute left-3.5 top-1/2 flex -translate-y-1/2 text-neutral-400"
      >
        <slot name="icon" />
      </div>

      <input
        :id="id"
        :class="`${slots['icon'] ? 'pl-[2.5rem]' : ''} ${errors.length ? 'ring-error' : 'ring-gray-200'} w-full truncate rounded-md border-0 bg-white px-3.5 py-2.5 text-zinc-800 shadow-[0px_1px_2px_0px_#2A33420D] ring-1 ring-inset placeholder:text-zinc-500 focus:ring-2 focus:ring-inset focus:!ring-secondary disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:text-zinc-500 disabled:placeholder:text-zinc-300`"
        type="text"
        :placeholder="placeholder"
        :value="value"
        :disabled="disabled"
        :required="required"
        @input="handleInput"
      />
    </div>

    <div v-if="errors.length" class="mt-2 space-y-1">
      <span
        v-for="(error, index) in errors"
        :key="index"
        class="block text-xs text-error"
      >
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script setup>
  import { useSlots } from 'vue';

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, null],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    }
  });

  const emits = defineEmits(['update:value', 'update:errors']);

  const slots = useSlots();

  function handleInput(event) {
    emits('update:value', event.target.value);
    emits('update:errors', []);
  }
</script>
